/* eslint-disable max-statements */
import { Button, ButtonGroup } from "react-bootstrap";
import { FilterIcon } from "@heroicons/react/outline";
import PropTypes from "prop-types";
import { useCallback } from "react";
import { useMediaQuery } from "react-responsive";

import { Default, Desktop, LargeDesktop } from "../../../components/Devices";
import { useClassFilters } from "./ClassFilterProvider";

import CalendarMonthNavigator from "./CalendarMonthCycle";

import { calendarViews as views } from "../../../helpers/event";

const buttonSize = "";
const buttonStyle = "outline-bluetype6";

const CalendarToolbar = ({
	setShowAll,
	showAll
}) => {

	const {
		setDate,
		showFilters,
		toggleFilters,
		isFiltered,
		setView,
		view,
		setFacetValues
	} = useClassFilters();

	const isTabletOrMobile = useMediaQuery({ maxWidth: 991 });
	const handleView = useCallback((_view) => () => setView(_view), []);
	const handleToday = useCallback(() => setDate(new Date()), []);
	const toggleShowAll = useCallback(() => setShowAll((prev) => !prev), []);
	const handleResetFilters = useCallback((evt) => {
		evt.preventDefault();
		setFacetValues({});
	}, []);

	return (
		<div className="calendar-toolbar d-flex mb-4 flex-column-reverse flex-md-row">
			<CalendarMonthNavigator />
			<div className="d-flex flex-fill justify-content-end mb-4 mb-md-0">
				<Default>
					{setShowAll ? (
						<Button
							active={showAll}
							className="me-3"
							onClick={toggleShowAll}
							variant={buttonStyle}
						>
							Show All
						</Button>
					) : null}
				</Default>

				<ButtonGroup className="me-3" size={buttonSize}>
					{views.map((_view) => (!isTabletOrMobile || _view[2]) && (
						<Button
							active={view === _view[0]}
							key={_view[0]}
							onClick={handleView(_view[0])}
							variant={buttonStyle}
						>{_view[1]}</Button>
					))}
				</ButtonGroup>
				<Button className="me-3" onClick={handleToday} size={buttonSize} variant={buttonStyle}>Today</Button>

				<Desktop>
					<ButtonGroup
						className={isFiltered ? "has-filters" : ""}
					>
						<Button
							onClick={toggleFilters}
							size={buttonSize}
							variant={buttonStyle}
						>
							<FilterIcon className="i me-1" />
							<LargeDesktop>
								{ showFilters ? "Hide" : "Show" } Filters
							</LargeDesktop>
						</Button>
						<Button
							onClick={handleResetFilters}
							size={buttonSize}
							variant={buttonStyle}
						>Reset</Button>
					</ButtonGroup>
				</Desktop>
			</div>
		</div>
	);
};

CalendarToolbar.propTypes = {
	setShowAll: PropTypes.func,
	showAll: PropTypes.bool
};

CalendarToolbar.defaultProps = {
	setShowAll: null,
	showAll: false
};

export default CalendarToolbar;
